module.exports = __webpack_public_path__ + "azure-logo-icon-8e55ade13d6df9ebe10fc45b87427875.png";